import { Settings as LayoutSettings } from '@ant-design/pro-components';

const Settings: LayoutSettings & {
  pwa?: boolean;
  logo?: string;
  publicPath?: string;
} = {
  navTheme: 'light',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: 'xCurrency Hubs Partner Platform',
  pwa: false,
  logo: '//public.tratao.com/icon/logo.svg',
  iconfontUrl: '//at.alicdn.com/t/c/font_4439984_cnclmdvs73k.js',
  publicPath: '',
};

export default Settings;
